module.exports = __webpack_public_path__ + "static/ghost-wars-671ce4dc8d92ee02558be78374470911.jpg";